/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommerceModeEnum } from './commerceModeEnum';


export interface DisconnectedComponentConfigSpecCommerce { 
    features?: Array<string>;
    mode?: CommerceModeEnum;
    valid_until?: Date;
}
export namespace DisconnectedComponentConfigSpecCommerce {
}


